import { useMemo } from 'react';
import cn from 'classnames';
import { Icon } from 'ht-styleguide';
import { PLAN_BENEFITS_IDS } from 'src/constants/planBenefits';
import { TPlansBenefits, TPlansDetails } from 'types/plans.types';
import BenefitBlock from '../BenefitBlock';
import styles from './pricing.module.scss';

const { ONLINE, CHECKUP, ANTIVIRUS, PASSWORD, IN_HOME, HOME_TECH, PRODUCT } = PLAN_BENEFITS_IDS;
const CHECK_FLAG = 'CHECK';
const EXTRA_BREAKDOWN_VALUES = [
  { id: HOME_TECH, smartHomeCopy: CHECK_FLAG, secondaryCopy: CHECK_FLAG },
  { id: ONLINE, smartHomeCopy: CHECK_FLAG, secondaryCopy: CHECK_FLAG },
  { id: IN_HOME, smartHomeCopy: CHECK_FLAG, secondaryCopy: '' },
  { id: PRODUCT, smartHomeCopy: CHECK_FLAG, secondaryCopy: '' },
  { id: CHECKUP, smartHomeCopy: CHECK_FLAG, secondaryCopy: '' },
  { id: ANTIVIRUS, smartHomeCopy: CHECK_FLAG, secondaryCopy: '' },
  { id: PASSWORD, smartHomeCopy: CHECK_FLAG, secondaryCopy: '' },
];

/*
  Show copy or a checkmark based on the copy value.
*/

type BreakdownValueProps = {
  copy: string;
};

const BreakdownValue = ({ copy }: BreakdownValueProps) => {
  const isCopyCheckFlag = copy === CHECK_FLAG;

  return isCopyCheckFlag ? <Icon name="checkmark-v2" className={styles.iconCheckmark} /> : <p className="h6 n900">{copy}</p>;
};

type BenefitsBreakdownProps = {
  smartHomePlan: TPlansDetails['smartHome'];
  billingCycle: string;
};
const BenefitsBreakdown = ({ smartHomePlan, billingCycle }: BenefitsBreakdownProps) => {
  const { benefits } = smartHomePlan[billingCycle] || {};

  const breakdown = useMemo(
    () =>
      (benefits as TPlansBenefits[]).map((benefit: { id: string }) => {
        let extra = EXTRA_BREAKDOWN_VALUES.find(e => benefit.id === e.id);
        if (extra?.id === IN_HOME) {
          extra = {
            ...extra,
          };
        }
        return {
          ...benefit,
          ...extra,
        };
      }),
    [benefits],
  );

  return (
    <div className={styles.benefitsContainer}>
      {breakdown.map((b: any, i: any) => {
        const paddingClass = i ? 'paddingTop-small2' : '';
        return (
          <div className={cn(styles.row)} key={b?.id}>
            <div className={cn(styles.selectPlanCol, paddingClass)}>
              <BenefitBlock benefitInfo={b} />
            </div>
            <div className={cn(styles.smartHomeCol, paddingClass)}>
              <BreakdownValue copy={b.smartHomeCopy} />
            </div>
            <div className={cn(styles.secondaryCol, paddingClass)}>
              <BreakdownValue copy={b.secondaryCopy} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BenefitsBreakdown;
